import Styles from "../CSS/header.module.css";
import App_logo_Svg from "../../assets/Svg/App_logo_Svg";
import { Link, NavLink } from "react-router-dom";
import Sidebar from "./Sidebar";
import { useState } from "react";
import Navopen from "../../assets/Svg/Nav_Open_Svg";
import Navclose from "../../assets/Svg/Nav_Close_Svg";
const Header = () => {
 const [showMenu, setShowMenu] = useState(false);

 const toggleMenu = () => {
  setShowMenu(!showMenu);
 };

 const closeMenu = () => {
  setShowMenu(false);
 };

 return (
  <div className={Styles.container}>
   <div className={Styles.header}>
    <div className={Styles.leftside}>
     <div className={Styles.headerSvgContainer}>
      <a
       style={{
        display: "flex",
        width: "100%",
        height: "80%",
        justifyContent: "center",
        alignItems: "center",
       }}
       href="http://imeconsys.com/"
      >
       <App_logo_Svg />
      </a>
     </div>
    </div>
    <div className={Styles.rightside}>
     <div className={Styles.navItemsContainer}>
      <p className={Styles.navItems}>
       {" "}
       <NavLink
        to="/"
        className={({ isActive }) =>
         isActive ? `${Styles.navItems} ${Styles.active}` : Styles.navItems
        }
       >
        Home
       </NavLink>
      </p>
      <p className={Styles.navItems}>
       {" "}
       <NavLink
        to="/about"
        className={({ isActive }) =>
         isActive ? `${Styles.navItems} ${Styles.active}` : Styles.navItems
        }
       >
        About
       </NavLink>
      </p>
      <p className={Styles.navItems}>
       {" "}
       <NavLink
        to="/services"
        className={({ isActive }) =>
         isActive ? `${Styles.navItems} ${Styles.active}` : Styles.navItems
        }
       >
        Services
       </NavLink>
      </p>
     </div>
    </div>
    <div className={Styles.rightsideMobile}>
     <div className={Styles.navItemsContainerMobile}>
      <i onClick={toggleMenu}>{showMenu ? <Navclose /> : <Navopen />}</i>
     </div>
    </div>
   </div>
   <Sidebar show={showMenu} onClose={toggleMenu} />
  </div>
 );
};
export default Header;
